import { locales, type Locale } from "@/i18n/config";

// Keep language names in their own language so a visitor can identify the choice before
// understanding the page copy. This is shared by the public landing selector and app settings.
export const languageNames: Record<Locale, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  pt: "Português",
  nl: "Nederlands",
  pl: "Polski",
  ru: "Русский",
  ja: "日本語",
  "zh-CN": "中文 (简体)",
  ko: "한국어",
  ar: "العربية",
  tr: "Türkçe",
  sv: "Svenska",
  cs: "Čeština",
  ro: "Română",
  hi: "हिन्दी",
  vi: "Tiếng Việt",
  id: "Bahasa Indonesia",
  uk: "Українська",
};

export const localeFlags: Partial<Record<Locale, string>> = {
  en: "🇬🇧", es: "🇪🇸", fr: "🇫🇷", de: "🇩🇪", it: "🇮🇹", pt: "🇵🇹", nl: "🇳🇱",
  pl: "🇵🇱", ru: "🇷🇺", uk: "🇺🇦", cs: "🇨🇿", ro: "🇷🇴", tr: "🇹🇷", ar: "🇸🇦",
  ja: "🇯🇵", "zh-CN": "🇨🇳", ko: "🇰🇷", hi: "🇮🇳", id: "🇮🇩", vi: "🇻🇳", sv: "🇸🇪",
};

const popularLanguages: Locale[] = [
  "en", "es", "fr", "de", "it", "pt", "nl", "pl", "ru", "ja",
  "zh-CN", "ko", "ar", "tr", "sv", "uk", "cs", "ro", "hi", "id",
];

export const sortedLocales: Locale[] = [
  ...popularLanguages.filter((locale) => locales.includes(locale)),
  ...locales
    .filter((locale) => !popularLanguages.includes(locale))
    .sort((a, b) => languageNames[a].localeCompare(languageNames[b])),
];

export function getLanguageFlag(locale: Locale): string {
  return localeFlags[locale] ?? "🌐";
}
